import * as angular from "angular";
// import "@meltwater/mi-manifest-client"; // Load the client onto the window object
import { EXTERNAL_NAME } from "@meltwater/mi-manifest-client/build/external-name.js";

export default angular
  .module("MW.Framework.AppChromeResponsiveController", [
    "ngMaterial",
    "mwAppComponents",
    "sharable-dashboard.state-service",
  ])
  .controller("AppChromeResponsiveController", [
    "$scope",
    "$rootScope",
    "$mdToast",
    "$mdDialog",
    "$mdMedia",
    "$location",
    "$window",
    "$cookies",
    "$http",
    "$q",
    "stateService",
    "FAIRHAIR_WEB_URL",
    "ANALYZE_WEB_URL",
    "PR_INSIGHT_REPORT_WEB",
    "ACCOUNTS_APP_URL",
    "GYDA_COOKIE_DOMAIN",
    "CoreCompanyService",
    "CoreUserService",
    "SHARABLE_DASHBOARD_URL",
    "DASHBOARD_SERVICES_URL",
    function (
      $scope,
      $rootScope,
      $mdToast,
      $mdDialog,
      $mdMedia,
      $location,
      $window,
      $cookies,
      $http,
      $q,
      stateService,
      FAIRHAIR_WEB_URL,
      ANALYZE_WEB_URL,
      PR_INSIGHT_REPORT_WEB,
      ACCOUNTS_APP_URL,
      GYDA_COOKIE_DOMAIN,
      CoreCompanyService,
      CoreUserService,
      SHARABLE_DASHBOARD_URL,
      DASHBOARD_SERVICES_URL
    ) {
      this.scope = $scope;
      this.$mdToast = $mdToast;
      this.$mdDialog = $mdDialog;
      this.$mdMedia = $mdMedia;
      this.$location = $location;
      this.$window = $window;
      this.$http = $http;
      this.stateService = stateService;
      this.CoreCompanyService = CoreCompanyService;
      this.CoreUserService = CoreUserService;
      this.DASHBOARD_SERVICES_URL = DASHBOARD_SERVICES_URL;
      // hook the client object off the window object

      // this.headerText = 'PR Insight Report';
      this.hideChrome = false;
      this.userMenuMainHeaderUrl = FAIRHAIR_WEB_URL + "/settings/personal";

      const manifestClient: any = window[EXTERNAL_NAME];
      if (!manifestClient) {
        throw new Error(
          "[Daily Digest Component]: Could not find Manifest Client"
        );
      }
      let instance;
      let currentManifestEnvironment;
      const currentManiHostName = window.location.hostname;

      if (currentManiHostName.indexOf(".com") !== -1) {
        currentManifestEnvironment = manifestClient.Environments.PRODUCTION;
      } else {
        currentManifestEnvironment = manifestClient.Environments.STAGING;
      }

      manifestClient.Initializer.initialize(currentManifestEnvironment);

      var inSettings =
        this.$location.url().indexOf("/facebook_login") >= 0 ? true : false;

      this.getEntitlement = async function () {
        const maniInstance = await manifestClient.ManifestClient.getInstance();
        const mani = await maniInstance.getCurrentManifest();
        this.stateService.entitlements = mani.entitlements.v6;
      };

      this.getEntitlement();

      this.CoreCompanyService.getCurrent(true).then(
        function (company) {
          if (this.$window.AppChrome && this.$window.AppChrome.ready === true) {
            this.$window.appContainerPlaceholder.remove();
          } else {
            this.$window.addEventListener("app-chrome-ready", () => {
              if (this.$window.appContainerPlaceholder) {
                this.$window.appContainerPlaceholder.remove();
              }
            });
          }
          this.attachNavigationEvent();
          this.company = company;
        }.bind(this)
      );

      this.getScreenSize = function () {
        if (this.$mdMedia("xs")) {
          return "xs";
        }
        if (this.$mdMedia("sm")) {
          return "sm";
        }
        if (this.$mdMedia("md")) {
          return "md";
        }
        if (this.$mdMedia("lg")) {
          return "lg";
        }
        if (this.$mdMedia("xl")) {
          return "xl";
        }
      };

      this.attachNavigationEvent = function () {
        // You can add a call to this function (or copy/paste the code) into your app component's init.
        $window.addEventListener(
          "app-chrome-location-change-internal-app",
          (event) => {
            // This event will fire any time navigation is triggered. It can be canceled to prevent that
            // navigation. Note that you will be responsible for updating the navigation when you navigate. You can do that by
            // calling $window.AppChrome.updateActivePage() when navigation occurs.
            event.preventDefault();
            $location.path(event.detail.location);
            $rootScope.$apply();
          }
        );

        $rootScope.$on("$locationChangeSuccess", function () {
          // This triggers the header and navigation to update the active navigation item as you navigate through your app.
          $window.AppChrome.updateActivePage();
          // This will cause the app to jump to the top of the page any time a navigation completes
          $window.AppChrome.scrollToContentTop();
        });
      };

      this.logout = function (event) {
        $cookies.remove("gydaToken", {
          domain: "insight-report.meltwater.com/",
        });
        $cookies.remove("gydaToken", { domain: GYDA_COOKIE_DOMAIN });
        $window.location.assign(ACCOUNTS_APP_URL + "/logout");
      }.bind(this);

      this.CoreUserService.getCurrent(true).then(
        function getCurrentSccuess(user) {
          this.user = user;
        }.bind(this)
      );

      this.openGAConsent = function () {
        this.$window.open("/ga_consent", "_self");
      };
    },
  ]);
